/**
 * @fileoverview
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.UT.PROTO.PriceMethodNew', null, global);
goog.exportSymbol('proto.UT.PROTO.StopLossTargetProfitPriceType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebAlertCondition', null, global);
goog.exportSymbol('proto.UT.PROTO.WebAlertStatus', null, global);
/**
 * @enum {number}
 */
proto.UT.PROTO.WebAlertStatus = {
  WEBALERTSTATUS_PENDING: 0,
  WEBALERTSTATUS_ACCEPT: 1,
  WEBALERTSTATUS_REJECT: 2,
  WEBALERTSTATUS_TIMEOUT: 3,
  WEBALERTSTATUS_INVALID: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebAlertCondition = {
  ALERTCONDITION_ENTRY: 0,
  ALERTCONDITION_EXIT: 1,
  ALERTCONDITION_REPAIR: 2,
  ALERTCONDITION_BID: 3,
  ALERTCONDITION_HEDGE: 4,
  ALERTCONDITION_LOAD: 5,
  ALERTCONDITION_UNLOAD: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.PriceMethodNew = {
  PRICEMETHODNEW_ANCHOR: 0,
  PRICEMETHODNEW_BBA: 1,
  PRICEMETHODNEW_HBA: 2,
  PRICEMETHODNEW_LOWEST_PRICE: 3,
  PRICEMETHODNEW_PRICEPOINT: 4,
  PRICEMETHODNEW_HTC: 5,
  PRICEMETHODNEW_MID_PRICE: 6,
  PRICEMETHODNEW_CLOSE_PRICE: 7,
  PRICEMETHODNEW_MARKET: 8,
  PRICEMETHODNEW_PURE_MARKET: 9,
  PRICEMETHODNEW_LTP: 10
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StopLossTargetProfitPriceType = {
  PRICETYPE_IN_PRICE: 0,
  PRICETYPE_IN_PERCENTAGE: 1
};

goog.object.extend(exports, proto.UT.PROTO);
